import 'normalize.css';
import '@/assets/stylus/common.styl';

import 'swiper/dist/css/swiper.min.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

window.$ = window.jQuery = require('jquery');
window.cookie = require('jquery.cookie/jquery.cookie.js');
window.Swiper = require('swiper/dist/js/swiper.min.js');
window.fancybox = require('@fancyapps/fancybox/dist/jquery.fancybox.min.js');
window.PerfectScrollbar = require('perfect-scrollbar/dist/perfect-scrollbar.js');
window.imagesLoaded = require('imagesloaded/imagesloaded.pkgd.js');

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import store from './store';
import VueMask from 'v-mask';

Vue.use(VueMask);

//Vue.use(VueResource);

Vue.config.productionTip = false;

UniHelpersTips('https://api-703594.pr-uni.ru/resources/heplers/tips/ajaxGetTips.php');

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');